import { supabase } from '../supabase';
import { normalizeSupabaseError } from './errors';

export interface ChurchNameSuggestion {
  name: string;
  usage_count: number;
}

export async function listChurchNames(
  search = '',
  limit = 20
): Promise<ChurchNameSuggestion[]> {
  const { data, error } = await supabase.rpc('list_church_names', {
    search,
    result_limit: limit,
  });
  if (error) throw normalizeSupabaseError(error);
  return (data as ChurchNameSuggestion[]) || [];
}

export async function listChurchNamesWithCounts(limit = 500): Promise<ChurchNameSuggestion[]> {
  return listChurchNames('', limit);
}

export async function mergeChurchNames(
  variants: string[],
  canonical: string
): Promise<number> {
  const trimmedCanonical = canonical.trim();
  if (!trimmedCanonical) {
    throw new Error('Canonical church name is required');
  }

  const namesToMerge = variants
    .map((v) => v.trim())
    .filter((v) => v && v !== trimmedCanonical);

  if (namesToMerge.length === 0) {
    return 0;
  }

  const allNames = [...namesToMerge, trimmedCanonical];
  const { data, error } = await supabase
    .from('church_info')
    .update({ church_name: trimmedCanonical })
    .in('church_name', allNames)
    .select('id');

  if (error) throw normalizeSupabaseError(error);
  return data?.length ?? 0;
}
